var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocInprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#DBEFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8333 15.666H18.9999C18.5579 15.666 18.134 15.8416 17.8214 16.1542C17.5088 16.4667 17.3333 16.8907 17.3333 17.3327V30.666C17.3333 31.108 17.5088 31.532 17.8214 31.8445C18.134 32.1571 18.5579 32.3327 18.9999 32.3327H28.9999C29.4419 32.3327 29.8659 32.1571 30.1784 31.8445C30.491 31.532 30.6666 31.108 30.6666 30.666V21.4993M24.8333 15.666L30.6666 21.4993M24.8333 15.666V21.4993H30.6666",
    stroke: "#1C8ACA",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocInprogress);
export default __webpack_public_path__ + "static/media/doc_inprogress.da783a12284d3acda66e13c29e2f82ad.svg";
export { ForwardRef as ReactComponent };